/**
 * AddBackgroundController
 *
 * @author Razvan Migea <razvan.migea@target-e.com>
 */
Pluswerk.PlusProject.PlusSolr = Pluswerk.PlusProject.PlusSolr || {};

Pluswerk.PlusProject.PlusSolr.AddBackgroundController = function () {
  var wrapper = $('.js-parentBackground').parent();
  wrapper.addClass('background-color-grey');
};
